import Client from '@/lib/axios';

const axios = Client();

export const getSocialMedia = async () => axios.get(`/socials/active`);
